import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { CustomerType } from '@/store/types/user'

export interface HydraGetSkuAvailabilityProps {
  customerType: CustomerType
  alpha2: Alpha2CountryCode
  skus: string[]
  shippingMethod?: string
}

export type HydraGetSkuAvailabilityResponse = {
  items: {
    currency: string
    customer: {
      type: string
    }
    lines: {
      items: {
        item: {
          catalogSlide: {
            content: {
              description: string
            }
          }
          dimensionsEach: {
            depth: number
            height: number
            unit: string
            width: number
          }
          id: {
            unicity: string
          }
          taxedAs: string
          href: string
        }
        quantity: number
        quantityLimit: {
          quantityOrdered: number
          quantityQuota: number
          timeFrameDays: number
        }
        terms: {
          cvEach: number
          discountEach: {
            amount: number
          }
          priceEach: number
          pvEach: number
          tax: {
            categoryDescription: string
          }
          taxEach: {
            amount: number
          }
          taxablePriceEach: number
        }
        quantityDetails: {
          quantityAvailable: number
          quantityBackordered: number
          quantitySellable: number
        }
      }[]
    }
  }[]
}

export const HydraGetSkuAvailability = async ({
  customerType,
  alpha2,
  skus,
  shippingMethod = 'Economy',
}: HydraGetSkuAvailabilityProps) => {
  const request: SendRequestType = {
    method: 'POST',
    url: `/quotes`,
    withAuth: false,
    returnType: 'json',
    data: {
      order: {
        market: alpha2,
        customer: {
          href: `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/customers?type=${customerType}`,
        },
        shipToAddress: {
          country: alpha2,
        },
        shippingMethod: {
          href: `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/shippingmethods?type=${shippingMethod}`,
        },
      },
      vary: {
        lines: {
          items: [
            {
              item: {
                href: `${
                  process.env.NEXT_PUBLIC_HYDRA_BASE_URL
                }/items?id.unicity=${skus.join('|')}`,
              },
              quantity: '?',
            },
          ],
        },
      },
    },
  }

  return httpTools.sendRequest<HydraGetSkuAvailabilityResponse>(request)
}
